module.exports = __webpack_public_path__ + "img/user-orange.1f9f8701.svg";